<template>
    <div class="badge-wrap">
        <img v-for="(cnt, id) in base" v-show="visible(id, cnt)" :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/badge_${id}.png`" :class="`badge-img badge${id}`" />
    </div>
</template>

<script>
    export default {
        data() {
            return {
                base: {
                    2: 3,
                    3: 4,
                    5: 3,
                    6: 4,
                    8: 3,
                    9: 1,
                    11: 3,
                    12: 4,
                },
            }
        },

        computed: {
            badges() {
                return this.$userData.badgeCount
            },
            condition() {
                return this.$userData.badgeCondition
            },
            visible() {
                return (id, cnt) => {
                    const visible = this.badges[id] === cnt

                    if (visible) {
                        if (this.$userData.badges[id]) return

                        this.$userData.badges[id] = true
                        setTimeout(_ => {
                            this.show(id)
                            setTimeout(_ => {
                                this.hide(id)
                            }, 3000)
                        })
                    }

                    return visible
                }
            }
        },

        beforeDestroy() {
            this.$eventBus.$off('ON_OPTION_SELECT')
        },

        mounted() {
            this.$eventBus.$on('CHANGE_AGE', _ => {
                $('.badge-img').hide()
            })

            this.$eventBus.$on('SHOW_BADGE', _ => {

            })

            this.$eventBus.$on('ON_OPTION_SELECT', (sequence, option) => {
                this.condition.forEach(cond => {
                    const seq = cond.sequence.split(',')
                    seq.forEach(val => {
                        if (val === sequence) {
                            if (cond.option === option) {
                                this.badges[cond.id] += cond.value
                                cond.value = 0
                            }
                        }
                    })
                })
            })
        },

        methods: {

            show(id) {
                this.$playAudio(14)
                $(`.badge${id}`).show().removeClass('hide').addClass('show')
                this.$gameData.isBadgeShown = true
            },

            hide(id) {
                $(`.badge${id}`).removeClass('show').addClass('hide')
                this.$gameData.isBadgeShown = false
            }

        }
    }
</script>

<style lang="scss" scoped>

    .badge-wrap {
        position: absolute;
        left: 180px;
        bottom: 100px;
        height: 81px;
        pointer-events: none;

        img {
            position: absolute;
            left: 0;
            top: 0;
            pointer-events: none;
        }

        .hide {
            -webkit-animation: fade-out-bck 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
            animation: fade-out-bck 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
        }

        .show {
            -webkit-animation: bounce-in-fwd 0.5s ease-in-out forwards;
            animation: bounce-in-fwd 0.5s ease-in-out forwards;
        }
    }
</style>

<style>


    /**
     * ----------------------------------------
     * animation bounce-in-fwd
     * ----------------------------------------
     */
    @-webkit-keyframes bounce-in-fwd {
        0% {
            -webkit-transform: scale(0);
            transform: scale(0);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
            opacity: 0;
        }
        38% {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
            opacity: 1;
        }
        55% {
            -webkit-transform: scale(0.7);
            transform: scale(0.7);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        72% {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
        }
        81% {
            -webkit-transform: scale(0.84);
            transform: scale(0.84);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        89% {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
        }
        95% {
            -webkit-transform: scale(0.95);
            transform: scale(0.95);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
        }
    }
    @keyframes bounce-in-fwd {
        0% {
            -webkit-transform: scale(0);
            transform: scale(0);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
            opacity: 0;
        }
        38% {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
            opacity: 1;
        }
        55% {
            -webkit-transform: scale(0.7);
            transform: scale(0.7);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        72% {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
        }
        81% {
            -webkit-transform: scale(0.84);
            transform: scale(0.84);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        89% {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
        }
        95% {
            -webkit-transform: scale(0.95);
            transform: scale(0.95);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
        }
    }

    /**
     * ----------------------------------------
     * animation fade-out-bck
     * ----------------------------------------
     */
    @-webkit-keyframes fade-out-bck {
        0% {
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            opacity: 1;
        }
        100% {
            -webkit-transform: translateZ(-80px);
            transform: translateZ(-80px);
            opacity: 0;
        }
    }
    @keyframes fade-out-bck {
        0% {
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            opacity: 1;
        }
        100% {
            -webkit-transform: translateZ(-80px);
            transform: translateZ(-80px);
            opacity: 0;
        }
    }


</style>
